<template>
    <div class="c">
        <div class="btn">
            <i class="iconfont icon-you1"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "btn"
    }
</script>

<style lang="scss" scoped>
.c{
    padding-top: 20px;
    .btn{
        width:60px;
        height:60px;
        border-radius: 50%;
        border: 1px solid rgba(0,0,0,.1);
        text-align: center;
        margin: 0 auto;
        position: relative;
        cursor: pointer;
        transition: all 2s;
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
        i{
            font-size: 20px;
            color:rgba(0,0,0,.3);
            position: absolute;
            left:34%;
            top:30%;
            transform: rotate(90deg);
            transition: all 2s;
        }
    }
    .btn:hover{
        background-color: #04356F;
        i{
            color:white;
        }
    }
}
</style>